import { RequestEventComponent } from './request-event/request-event.component';
import { ModalController } from '@ionic/angular';
import { Component, inject } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { IS_NEW_UI_FLOW } from '../../environments/environment';

interface Card {
    title?: string;
    content?: string;
    icon?: string;
    link?: string;
}
@Component({
  standalone: false,
    selector: 'app-website',
    templateUrl: './website.page.html',
    styleUrls: ['./website.page.scss'],
})
export class WebsitePage {
    private modalController = inject(ModalController);
    public IS_NEW_UI_FLOW = IS_NEW_UI_FLOW;

    cards: Card[] = [
        {
            title: 'Individual Matches',
            content: 'Track any singles or doubles match, assign trackers, share matches, get current weather. iOnCourt supports over 100 different score formats.',
            icon: 'person',
            link: 'https://ioncourt.com/live-scoring/63b9a2c96eef29e4c4808d4e'
        },
        {
            title: 'Team Matches',
            content: 'With iOnCourt you can use different college or high school team match templates or manually build any scorecard. Assign trackers to all matches or assign a tracker to each match individually. ',
            icon: 'people',
            link: 'https://ioncourt.com/ties/63b9a2c96eef29e4c4808631'
        },
        {
            title: 'Competitions',
            content: 'iOnCourt supports live score for leagues and tournaments. Get in touch with us if you have an event that needs real time updates.',
            icon: 'trophy'
        },
        {
            title: 'Share Match',
            content: 'You can generate a link that can be shared with coaches, players, and parents via messages, emails or social media of your choice straight from the app.',
            icon: 'share'
        },
        {
            title: 'Change Tracker',
            content: 'iOnCourt allows multiple users to track any match. It can be used to transfer a match from one person to another, or assign it to an on-court official.',
            icon: 'swap-horizontal'
        },
        {
            title: 'Tracking Modes',
            content: 'There are 3 levels of tracking: games and/or points only, basic stats including aces, winner, forced and unforced errors, and stats that include rally length and serve location.',
            icon: 'code-working'
        },
        {
            title: 'Advanced Stats',
            content: 'Get detailed stats that can be seen at professional tennis matches. Stats can be filtered based on player, returning side, rally length, or serve location.',
            icon: 'stats-chart'
        },
        {
            title: 'Momentum Chart',
            content: 'iOnCourt gives your graphic representation of momentum changes within the match. It helps you see patterns, such as streaks of points won, winners, or errors.',
            icon: 'pulse'
        }
    ];

    slidePages = [
        { img: '../assets/img/matches.PNG' },
        { img: '../assets/img/team.PNG' },
        { img: '../assets/img/board.PNG' },
        { img: '../assets/img/stats.PNG' },
        { img: '../assets/img/momentum.PNG' }
    ];

    slidesOptions = {
        initialSlide: 0,
        direction: 'horizontal',
        speed: 1500,
        slidesPerView: 1,
        slidesOffsetAfter: 0,
        autoplay: true
    };

    constructor() { }

    openAppStore() {
        const link = 'https://apps.apple.com/us/app/ioncourt-tennis-match-tracker/id1489506140';
        this.openLink(link);
    }

    openPlayStore() {
        const link = 'https://play.google.com/store/apps/details?id=com.ioncourt.tracker&hl=en_US&gl=US';
        this.openLink(link);
    }

    async openLink(link: string) {
        await Browser.open({
            url: link
        });
    }

    async openSocial(social) {
        let link: string;
        if (social === 'facebook') link = 'https://www.facebook.com/ioncourtapp';
        else if (social === 'instagram') link = 'https://www.instagram.com/ioncourtapp';
        else if (social === 'twitter') link = 'https://www.twitter.com/ioncourtapp';
        await Browser.open({
            url: link
        });
    }

    async openRequestForm() {
        const modal = await this.modalController.create({
            component: RequestEventComponent,
        });

        await modal.present();

    }
}
